import React from "react";
import { Table } from "react-bootstrap";
import { getGrade } from "../../utils/getGrade";
import "./GradeSummary.css";

/**
 * GradeSummary Component
 *
 * A reusable component that displays a summary table of grade distribution.
 * Shows all possible grades (A++, A+, A, A-, B, C) in columns and their counts in rows.
 *
 * @param {Array} data - Array of student objects with 'grade' property
 * @param {string} title - Optional title for the summary table (default: "Grade Summary")
 *
 * @example
 * <GradeSummary
 *   data={rankingData}
 *   title="Terminal Assessment Grade Summary"
 * />
 */
const GradeSummary = ({ data, title = "Grade Summary" }) => {
  // Define all possible grades in order
  const allGrades = ["A++", "A+", "A", "A-", "B", "C"];

  // Count grades from the data
  const countGrades = (data) => {
    const gradeCounts = allGrades.reduce((acc, grade) => {
      acc[grade] = 0;
      return acc;
    }, {});

    if (data && Array.isArray(data)) {
      data.forEach((student) => {
        const grade = student.grade;
        if (grade && gradeCounts.hasOwnProperty(grade)) {
          gradeCounts[grade]++;
        }
      });
    }

    return gradeCounts;
  };

  const gradeCounts = countGrades(data);

  return (
    <div className="grade-summary">
      <h6 className="mb-1 fw-bold text-center pt-4">{title}</h6>
      <Table striped bordered hover size="sm" className="mb-0">
        <thead className="table-primary">
          <tr>
            {allGrades.map((grade) => (
              <th key={grade} className="text-center">
                {grade}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {allGrades.map((grade) => (
              <td key={grade} className="text-center fw-bold">
                {gradeCounts[grade]}
              </td>
            ))}
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default GradeSummary;
